import React, { useEffect, useState } from 'react'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import RightModal from '../../Modals/RightModal';
import { ReactComponent as PlusPrimary } from '../../../assets/icons/PlusPrimary.svg';
import InputSelect from '../../InputGroup/InputSelect';
import InputTextarea from '../../InputGroup/InputTextarea';
import InputText from '../../InputGroup/InputText';
import { updateSpecifications } from '../../../services/public/public.service';
import { toast } from 'react-toastify';
import { specificationsList } from '../../../utils/project-constant';

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '44px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
        // '&:hover': { borderColor: '#ced4da' },



        // You can also use state.isFocused to conditionally style based on the focus state
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: state.isSelected ? '#44444F' : '#44444F',
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        }
    }),
};

// const specificationList = [
//     {
//         label: 'Master Bedroom-Walls',
//         value: 'Master Bedroom-Walls'
//     },
//     {
//         label: 'Master Bedroom-Flooring',
//         value: 'Master Bedroom-Flooring'
//     },
//     {
//         label: 'Other Bedrooms-Flooring',
//         value: 'Other Bedrooms-Flooring'
//     },
//     {
//         label: 'Walls',
//         value: 'Walls'
//     },
//     {
//         label: 'Living Area-Flooring',
//         value: 'Living Area-Flooring'
//     },
//     {
//         label: 'Bathroom',
//         value: 'Bathroom'
//     },
//     {
//         label: 'Structure',
//         value: 'Structure'
//     },
//     {
//         label: 'Other',
//         value: 'Other'
//     }
// ]


const SpecificationModal = ({ show, closeModal, style, setSpecifications, selectedSpecification, getSpecifications }) => {
    const [addedSpecifications, setAddedSpecifications] = useState([{}, {}]);
    const [selectedIndex, setSelectedIndex] = useState('');

    useEffect(() => {
        if (selectedSpecification.uuid) {
            setAddedSpecifications([selectedSpecification])
        }
    }, [selectedSpecification]);

    const handleSubmit = () => {
        const mapping = addedSpecifications.map(item => ({ type: item?.type?.value || item?.other, value: item.value }))
        setSpecifications(mapping)
        closeModal();
    }

    const handleUpdate = async () => {
        const res = await updateSpecifications(selectedSpecification.uuid, addedSpecifications[0]);
        if (res.data.status === 200) {
            toast.success(res.data.message);
            getSpecifications();
            closeModal();
        }
    }

    return (
        <RightModal show={show} closeModal={() => { closeModal(); }}
            modalClass={`${style.configurationModal}  configurationModal`}>
            <div className='d-flex justify-content-between border-bottom border-color px-20 py-16'>
                <h1 className='mb-0 black inter fz20 fw-po-medium'>
                    {/* {selectedBankDetail?.uuid ? 'Edit' : 'Add'} */}
                    Add Project Specification
                </h1>
                <button className='border-0 bg-tr ' onClick={() => {
                    closeModal();
                }}><CloseIcon /></button>
            </div>
            <div className={`${style.modalForm} d-flex h-100 overflow-auto flex-column px-20`}>
                {
                    addedSpecifications.map((specification, index) => (
                        <div
                            className='!border !border-grayLight  !py-4 !px-4 bg-[#F9FAFD] rounded-lg gap-y-4 flex flex-col'
                            key={`specification_${index}`}
                        >
                            <div>
                                <h4 className='inter text-sm text-black700 !mb-2'>Specification {index + 1}</h4>
                                <div className='grid grid-cols-1 gap-x-9	gap-y-4'>
                                    <InputSelect
                                        placeholder='Select Specification Type'
                                        isMulti={false}
                                        styles={customStyles}
                                        options={specificationsList}
                                        value={specification.type ? specificationsList.find(item => item.value === specification.type) : ''}
                                        onChange={(value) => {
                                            if (value.value !== 'Other Specifications') {
                                                let speciValues = [...addedSpecifications];
                                                speciValues[index].type = value
                                                setAddedSpecifications([...speciValues])
                                            } else {
                                                setSelectedIndex(index)
                                            }
                                        }}
                                    />
                                    {selectedIndex === index && <InputText
                                        type="text"
                                        label="Specification Type"
                                        placeholder="Specification Type"
                                        name="name"
                                        inputclass='m-0 inter'
                                        value={specification.other}
                                        onChange={(e) => {
                                            let speciValues = [...addedSpecifications];
                                            speciValues[index].other = e.target.value
                                            setAddedSpecifications([...speciValues])
                                        }}
                                    />}
                                    <InputTextarea
                                        type="text"
                                        // label="Payment Plan Description"
                                        placeholder="Specification Description"
                                        name="name"
                                        inputclass='m-0 inter'
                                        row='2'
                                        value={specification.value}
                                        onChange={(e) => {
                                            let speciValues = [...addedSpecifications];
                                            speciValues[index].value = e.target.value
                                            setAddedSpecifications([...speciValues])
                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                    ))
                }

                {/* <div className='!border !border-grayLight  !py-4 !px-4 bg-[#F9FAFD] rounded-lg gap-y-4 flex flex-col'>
                    <div>
                        <h4 className='inter text-sm text-black700 !mb-2'>Specification 2</h4>
                        <div className='grid grid-cols-1 gap-x-9 gap-y-4'>

                            <InputSelect
                                placeholder='Select Specification Type'
                                isMulti={false}
                                styles={customStyles}

                            />
                            <InputTextarea
                                type="text"
                                // label="Payment Plan Description"
                                placeholder="Specification Description"
                                name="name"
                                inputclass='m-0 inter'
                                row='2'
                            />

                        </div>
                    </div>
                </div> */}
                {!selectedSpecification?.uuid && <div>
                    <button
                        className='bg-blueHighlight !text-primary text-sm font-medium inter flex items-center gap-1 !px-4 !py-2 rounded-lg float-right'
                        onClick={() => setAddedSpecifications([...addedSpecifications, {}])}
                    >
                        <PlusPrimary />Add Specification</button>
                </div>}

            </div>
            <div className={`${style.righmodalfooter} d-flex flex-row align-items-center justify-content-between border-top border-color px-20 righmodalfooter`}>
                <button type='button' className='outline-btn w-100' onClick={() => { closeModal(); }}>Cancel</button>
                <button type='button'
                    className='pr-btn w-100'
                    onClick={() => {
                        if (selectedSpecification?.uuid) {
                            handleUpdate();
                        } else {
                            handleSubmit()
                        }
                    }}>
                    {selectedSpecification.uuid ? 'Update' : 'Submit'}
                </button>
            </div>
        </RightModal>
    )
}

export default SpecificationModal
